import type { ReactNode } from 'react';

export interface SignalBarsProps {
  readonly lit: number;
  readonly total?: number;
  /** Color of lit bars. Defaults to --color-pos. */
  readonly color?: string;
  readonly className?: string;
}

/**
 * Tiny health-indicator: 4 vertical bars of ascending height.
 * Used in MinerDetailSheet header and Miner-tab validator rows.
 *
 * Reference: docs/design_handoff/.../screens-settings.jsx SignalBars.
 */
export function SignalBars({
  lit,
  total = 4,
  color = 'var(--color-pos)',
  className = '',
}: SignalBarsProps): ReactNode {
  return (
    <span
      className={['inline-flex items-end gap-[2px]', className].filter(Boolean).join(' ')}
    >
      {Array.from({ length: total }).map((_, i) => {
        const isLit = i < lit;
        return (
          <span
            key={i}
            data-bar
            data-lit={isLit}
            style={{
              width: 3,
              height: `${4 + i * 2}px`,
              borderRadius: 1,
              background: isLit ? color : 'var(--color-border-hairline)',
            }}
          />
        );
      })}
    </span>
  );
}
